// 活动时间格式化
function formatDate(activity) {
  let start = activity.startDay.replace(/-/g, '.')
  let end = activity.endDay.replace(/-/g, '.')

  if (start.substring(11) == '00:00' || end.substring(11) == '00:00') {
    start = start.replace('00:00', '')
    end = end.replace('00:00', '')
  }
  if (start.substring(11) == '00:00:00' || end.substring(11) == '00:00:00') {
    start = start.replace('00:00:00', '')
    end = end.replace('00:00:00', '')
  }
  // 同一天
  if (start.substring(0, 10) == end.substring(0, 10)) {
    if (!end.substring(11) || start.substring(11) == end.substring(11)) {
      return start
    } else {
      return start + ' ~ ' + end.substring(11)
    }
  } else if (start.substring(0, 4) == end.substring(0, 4)) {
    return start + ' ~ ' + end.substring(5, end.length)
  } else {
    return start + ' ~ ' + end
  }
}

// 报名时间格式化
function formatOrderDate(activity) {
  let start = activity.regStartDay.replace(/-/g, '.')
  let end = activity.regEndDay.replace(/-/g, '.')

  if (start.substring(11) == '00:00' || end.substring(11) == '00:00') {
    start = start.replace('00:00', '')
    end = end.replace('00:00', '')
  }
  if (start.substring(11) == '00:00:00' || end.substring(11) == '00:00:00') {
    start = start.replace('00:00:00', '')
    end = end.replace('00:00:00', '')
  }
  // 同一天
  if (start.substring(0, 10) == end.substring(0, 10)) {
    if (!end.substring(11) || start.substring(11) == end.substring(11)) {
      return start
    } else {
      return start + ' ~ ' + end.substring(11)
    }
  } else if (start.substring(0, 4) == end.substring(0, 4)) {
    return start + ' ~ ' + end.substring(5, end.length)
  } else {
    return start + ' ~ ' + end
  }
}

export { formatDate, formatOrderDate }
